import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import { leaveApplications } from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = HRService.uri;
const actions = {
  entity: "Leave Applications",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  ApproveLeave: {
    key: "APPROVELEAVE",
    button_name: "Approve/Decline Leave",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  DeclineLeave: {
    key: "DECLINELEAVE",
    button_name: "Reject Leave",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  dataObject: {
    objectName: "approvedLeaveApplications",
    parameters: '',
  },

  actionName: "Leave Application ",
  showStatus: true,
};
function ApprovedLeavesTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Approved Leaves"
          subtitle="View All Approved Leaves"
          //columns={LeaveApplicationsColumns}
          //query={leaveApplications}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ApprovedLeavesTable;
